import axios from 'axios';
const header = {
  'Content-Type': 'application/json',
}

/*****************************First Fetched Masked Email and Mobile**************************** */
export const getMaskedPhoneAndEmail = async (activityId, eventCode, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_4f969b16", //uat
        "activityid": `${activityId}`,
        "coapplicant": `${coapplicant}`,
        "eventcode": `${eventCode}`,
        "lappType": "customer_doc_upload"
      },
      "orgId": "53450",//uat
      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config)
}
/************************************************************************************************ */

export const getApplicantDetailsForDocumentUpload = async (requestedActivityId, coapplicant) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_b01c8ce2",
        "activityid": `${requestedActivityId}`,
        "coapplicant": `${coapplicant}`,
        "operationType": "fetch"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config)
}

export const submitDocuments = async (body, activityDetails) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_b01c8ce2",// uat
        "operationType": "submit"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          documentList: body,
          activityDetails: activityDetails
        }
      }
    })
  }

  return await axios(config);
}

export const verifyOtpFromApi = async (activityId, eventcode, coapplicant, otp) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_fac81f28",// uat
        "otp": "verify"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          otp: otp,
          lappType: "customer_doc_upload"
        }
      }
    })
  }
  return await axios(config);
}

export const logVerificationResponse = async (activityDetails, status) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_b01c8ce2",// uat
        "operationType": "logVerificationDetails"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityDetails: activityDetails,
          otpStatus: status
        }
      }
    })
  }

  console.log("config >>>",JSON.stringify(config))

  return await axios(config)
}
export const sendOtpToMobileNumber = async (activityId, coapplicant, eventcode) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_fac81f28",// uat
        "otp": "send"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          messageType: 'documentUpload',
          lappType: "customer_doc_upload"
        }
      }
    })
  }
  return await axios(config);
}

